export class ErrorDto {
  description?: string;
  text?: string;
  errorCode?: string;
  message?: string;
  moreInfo?: string;

  constructor(d?: ErrorDto) {
    if (d) {
      this.description = d.description;
      this.text = d.text;
      this.errorCode = d.errorCode;
      this.message = d.message;
      this.moreInfo = d.moreInfo;
    }
  }
}
